<template>
  <div>
    <div v-show="open" class="cascader-selector card position-absolute">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'dropdown',
  props: {
    open: Boolean,
  }
};
</script>

<style scoped>

</style>
